import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en/translation.json';
import knTranslations from './locales/kn/translation.json';

i18n
  .use(LanguageDetector) // Auto-detect browser/phone language
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: enTranslations
      },
      kn: {
        translation: knTranslations
      }
      // Future languages can be added here:
      // te: { translation: teTranslations },
      // ta: { translation: taTranslations },
      // hi: { translation: hiTranslations }
    },
    fallbackLng: 'en', // Fallback to English if browser language not supported
    supportedLngs: ['en', 'kn'], // Supported languages (easy to add more later)
    detection: {
      order: ['localStorage', 'navigator'], // Check localStorage first, then browser settings
      caches: ['localStorage'], // Save user's language preference
    },
    interpolation: {
      escapeValue: false // React already escapes values
    }
  });

export default i18n;
